export default __webpack_public_path__ + "static/media/wave.8aa2e00d.svg";